export enum SummaryType {
    CIM = 'cim',
    VANILLA = 'vanilla'
}